/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createPassportFile = /* GraphQL */ `mutation CreatePassportFile(
  $input: CreatePassportFileInput!
  $condition: ModelPassportFileConditionInput
) {
  createPassportFile(input: $input, condition: $condition) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      password
      passport_url
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePassportFileMutationVariables,
  APITypes.CreatePassportFileMutation
>;
export const updatePassportFile = /* GraphQL */ `mutation UpdatePassportFile(
  $input: UpdatePassportFileInput!
  $condition: ModelPassportFileConditionInput
) {
  updatePassportFile(input: $input, condition: $condition) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      password
      passport_url
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePassportFileMutationVariables,
  APITypes.UpdatePassportFileMutation
>;
export const deletePassportFile = /* GraphQL */ `mutation DeletePassportFile(
  $input: DeletePassportFileInput!
  $condition: ModelPassportFileConditionInput
) {
  deletePassportFile(input: $input, condition: $condition) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      password
      passport_url
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePassportFileMutationVariables,
  APITypes.DeletePassportFileMutation
>;
export const createPassportFileSec = /* GraphQL */ `mutation CreatePassportFileSec(
  $input: CreatePassportFileSecInput!
  $condition: ModelPassportFileSecConditionInput
) {
  createPassportFileSec(input: $input, condition: $condition) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      profile_university
      password
      passport_url
      createdAt
      updatedAt
      owner
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePassportFileSecMutationVariables,
  APITypes.CreatePassportFileSecMutation
>;
export const updatePassportFileSec = /* GraphQL */ `mutation UpdatePassportFileSec(
  $input: UpdatePassportFileSecInput!
  $condition: ModelPassportFileSecConditionInput
) {
  updatePassportFileSec(input: $input, condition: $condition) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      profile_university
      password
      passport_url
      createdAt
      updatedAt
      owner
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePassportFileSecMutationVariables,
  APITypes.UpdatePassportFileSecMutation
>;
export const deletePassportFileSec = /* GraphQL */ `mutation DeletePassportFileSec(
  $input: DeletePassportFileSecInput!
  $condition: ModelPassportFileSecConditionInput
) {
  deletePassportFileSec(input: $input, condition: $condition) {
    id
    folder
    title
    url
    passportId
    passport {
      id
      passport_impact
      passport_strategies
      passport_network
      passport_signs
      passport_triggers
      passport_aspects
      mh_issues_current
      mh_issues_past
      mh_challenges
      neuro_details
      neuro_diagnosed
      neuro_challenges
      wb_current
      wb_past
      wb_challenges
      disabilty_details
      disabilty_difficulties
      disabilty_challenges
      profile_gp_details
      profile_support_network
      profile_contacts
      profile_support_services
      profile_work
      profile_dob
      profile_mood {
        mood
        date
        __typename
      }
      profile_university
      password
      passport_url
      createdAt
      updatedAt
      owner
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePassportFileSecMutationVariables,
  APITypes.DeletePassportFileSecMutation
>;
export const createPassport = /* GraphQL */ `mutation CreatePassport(
  $input: CreatePassportInput!
  $condition: ModelPassportConditionInput
) {
  createPassport(input: $input, condition: $condition) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    password
    passport_url
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePassportMutationVariables,
  APITypes.CreatePassportMutation
>;
export const updatePassport = /* GraphQL */ `mutation UpdatePassport(
  $input: UpdatePassportInput!
  $condition: ModelPassportConditionInput
) {
  updatePassport(input: $input, condition: $condition) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    password
    passport_url
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePassportMutationVariables,
  APITypes.UpdatePassportMutation
>;
export const deletePassport = /* GraphQL */ `mutation DeletePassport(
  $input: DeletePassportInput!
  $condition: ModelPassportConditionInput
) {
  deletePassport(input: $input, condition: $condition) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    password
    passport_url
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePassportMutationVariables,
  APITypes.DeletePassportMutation
>;
export const createPassportSec = /* GraphQL */ `mutation CreatePassportSec(
  $input: CreatePassportSecInput!
  $condition: ModelPassportSecConditionInput
) {
  createPassportSec(input: $input, condition: $condition) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    profile_university
    password
    passport_url
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePassportSecMutationVariables,
  APITypes.CreatePassportSecMutation
>;
export const updatePassportSec = /* GraphQL */ `mutation UpdatePassportSec(
  $input: UpdatePassportSecInput!
  $condition: ModelPassportSecConditionInput
) {
  updatePassportSec(input: $input, condition: $condition) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    profile_university
    password
    passport_url
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePassportSecMutationVariables,
  APITypes.UpdatePassportSecMutation
>;
export const deletePassportSec = /* GraphQL */ `mutation DeletePassportSec(
  $input: DeletePassportSecInput!
  $condition: ModelPassportSecConditionInput
) {
  deletePassportSec(input: $input, condition: $condition) {
    id
    passport_impact
    passport_strategies
    passport_network
    passport_signs
    passport_triggers
    passport_aspects
    mh_issues_current
    mh_issues_past
    mh_challenges
    neuro_details
    neuro_diagnosed
    neuro_challenges
    wb_current
    wb_past
    wb_challenges
    disabilty_details
    disabilty_difficulties
    disabilty_challenges
    profile_gp_details
    profile_support_network
    profile_contacts
    profile_support_services
    profile_work
    profile_dob
    profile_mood {
      mood
      date
      __typename
    }
    profile_university
    password
    passport_url
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePassportSecMutationVariables,
  APITypes.DeletePassportSecMutation
>;
export const createAssistant = /* GraphQL */ `mutation CreateAssistant(
  $input: CreateAssistantInput!
  $condition: ModelAssistantConditionInput
) {
  createAssistant(input: $input, condition: $condition) {
    id
    assistant_report
    assessment
    files_keys
    ocean
    location
    rank
    last_connection
    conditions_accepted
    daily_logs {
      items {
        id
        assistantId
        date
        mood
        tip_shown
        tip
        notes
        diagnostic
        rank
        created_at
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssistantMutationVariables,
  APITypes.CreateAssistantMutation
>;
export const updateAssistant = /* GraphQL */ `mutation UpdateAssistant(
  $input: UpdateAssistantInput!
  $condition: ModelAssistantConditionInput
) {
  updateAssistant(input: $input, condition: $condition) {
    id
    assistant_report
    assessment
    files_keys
    ocean
    location
    rank
    last_connection
    conditions_accepted
    daily_logs {
      items {
        id
        assistantId
        date
        mood
        tip_shown
        tip
        notes
        diagnostic
        rank
        created_at
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssistantMutationVariables,
  APITypes.UpdateAssistantMutation
>;
export const deleteAssistant = /* GraphQL */ `mutation DeleteAssistant(
  $input: DeleteAssistantInput!
  $condition: ModelAssistantConditionInput
) {
  deleteAssistant(input: $input, condition: $condition) {
    id
    assistant_report
    assessment
    files_keys
    ocean
    location
    rank
    last_connection
    conditions_accepted
    daily_logs {
      items {
        id
        assistantId
        date
        mood
        tip_shown
        tip
        notes
        diagnostic
        rank
        created_at
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssistantMutationVariables,
  APITypes.DeleteAssistantMutation
>;
export const createAssistantDailyLog = /* GraphQL */ `mutation CreateAssistantDailyLog(
  $input: CreateAssistantDailyLogInput!
  $condition: ModelAssistantDailyLogConditionInput
) {
  createAssistantDailyLog(input: $input, condition: $condition) {
    id
    assistantId
    assistant {
      id
      assistant_report
      assessment
      files_keys
      ocean
      location
      rank
      last_connection
      conditions_accepted
      daily_logs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    date
    mood
    tip_shown
    tip
    notes
    diagnostic
    rank
    created_at
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssistantDailyLogMutationVariables,
  APITypes.CreateAssistantDailyLogMutation
>;
export const updateAssistantDailyLog = /* GraphQL */ `mutation UpdateAssistantDailyLog(
  $input: UpdateAssistantDailyLogInput!
  $condition: ModelAssistantDailyLogConditionInput
) {
  updateAssistantDailyLog(input: $input, condition: $condition) {
    id
    assistantId
    assistant {
      id
      assistant_report
      assessment
      files_keys
      ocean
      location
      rank
      last_connection
      conditions_accepted
      daily_logs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    date
    mood
    tip_shown
    tip
    notes
    diagnostic
    rank
    created_at
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssistantDailyLogMutationVariables,
  APITypes.UpdateAssistantDailyLogMutation
>;
export const deleteAssistantDailyLog = /* GraphQL */ `mutation DeleteAssistantDailyLog(
  $input: DeleteAssistantDailyLogInput!
  $condition: ModelAssistantDailyLogConditionInput
) {
  deleteAssistantDailyLog(input: $input, condition: $condition) {
    id
    assistantId
    assistant {
      id
      assistant_report
      assessment
      files_keys
      ocean
      location
      rank
      last_connection
      conditions_accepted
      daily_logs {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    date
    mood
    tip_shown
    tip
    notes
    diagnostic
    rank
    created_at
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssistantDailyLogMutationVariables,
  APITypes.DeleteAssistantDailyLogMutation
>;
